<template>
    <div>
        <input type="hidden" :name="formFieldName" :value="selectedTicketId">
        <div v-if="!isInitialized && eventUuid">Loading ticket selector...</div>
        <div v-if="!isInitialized && !eventUuid">Ticket selector: Select event</div>
        <div v-if="isInitialized" class="resource-selector ">
            <multiselect :options="options"
                         @search-change="asyncQuery"
                         @select="select"
                         :internal-search="false"
                         v-model="selectedTicket"
                         :placeholder="placeholder"
                         :loading="isLoading"
                         :preserve-search="true"
                         :option-height="80">
                <template slot="singleLabel" slot-scope="{ option }">
                    <div class="search-dropdown">
                        <img class="option__image" :src="option.image">
                        <div class="option__desc">
                            <div class="option__title">
                                <span>{{ option.name }}</span>
                            </div>
                            <ul class="option__details">
                                <li>EUR {{ option.cost }}</li>
                                <li>Available: {{ option.available }}</li>
                            </ul>
                        </div>
                    </div>
                </template>
                <template slot="option" slot-scope="{ option }">
                    <div class="search-dropdown">
                        <img class="option__image" :src="option.image">
                        <div class="option__desc">
                            <div class="option__title">
                                <span>{{ option.name }}</span>
                            </div>
                            <ul class="option__details">
                                <li>EUR {{ option.cost }}</li>
                                <li>Available: {{ option.available }}</li>
                            </ul>
                        </div>
                    </div>
                </template>
                <template slot="noResult">
                    No results found
                </template>
                <template slot="noOptions">
                    Start searching by typing
                </template>
                <pre class="language-json"><code>{{ selectedTicket }}</code></pre>
            </multiselect>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _ from "lodash";
import axios from "axios";
import qs from "qs";

export default {
    components: { Multiselect },
    name: "TicketsSearch",
    props: {
        placeholder: {
            default: 'Search tickets...'
        },
        eventUuid: {
            required: true
        },
        partnerId: {
            required: true
        },
        formFieldName: {
            default: 'ticket_category_uuid'
        },
        prefilledTicketCategoryUuid: {
            default: null
        }
    },

    data: () => {
        return {
            options: [],
            selectedTicket: null,
            isLoading: false,
            isInitialized: false,
            couldNotFindPrefilledOption: false,
        };
    },

    mounted () {
        this.initialize();
    },

    computed: {

        selectedTicketId () {
            return this.selectedTicket?.uuid;
        }

    },

    watch: {
        eventUuid () {
            this.initialize();
        },

        partnerId () {
            this.initialize();
        },

        prefilledTicketCategoryUuid () {
            this.initialize();
        }
    },

    methods: {

        async initialize () {
            if (!this.eventUuid) return;

            this.reset();

            await this.fetchTickets('');

            if (this.prefilledTicketCategoryUuid) {
                const existingPrefilled = this.options.find(o => o.uuid === this.prefilledTicketCategoryUuid);

                if (existingPrefilled) {
                    this.select(existingPrefilled);
                    return;
                }

                this.couldNotFindPrefilledOption = true;
            }
        },

        asyncQuery: _.debounce(function(queryString) {
            if (!queryString) {
                this.options = [];
                return;
            }

            this.fetchTickets(queryString);
        }, 500),

        fetchTickets (queryString) {
            this.isLoading = true;

            const stringifiedQueryString = qs.stringify({
                filters: {
                    query: queryString,
                    eventUuid: this.eventUuid,
                    partnerId: this.partnerId
                }
            });

            return axios.get(`/admin/api/tickets?${stringifiedQueryString}`).then((resp) => {
                this.isLoading = false;
                this.isInitialized = true;
                this.options = resp.data.data;
            }).catch(() => {
                this.isLoading = false;
                this.isInitialized = true;
            });
        },

        select(resource) {
            this.selectedTicket = resource;
            this.$emit('ticket-selected', resource.uuid);
        },

        remove() {
            this.selectedTicket = null;
        },

        reset () {
            this.options = [];
            this.selectedTicket = null;
            this.isInitialized = false;
            this.couldNotFindPrefilledOption = false;
            this.isLoading = false;
        }
    }
};
</script>

<style scoped lang="scss">
.multiselect__element {
    border-bottom: 1px solid black;
}

.search-dropdown {
    display: flex;

    .option__image {
        width: 20%;
        max-width: 120px;
        padding: 0.1rem;
    }

    .option__desc {
        padding: 1rem;
        width: 100%;

        .option__title {
            font-weight: bold;
            font-size: 1.1rem;
        }

        ul.option__details {
            list-style-type: none;
            padding: 0;
            margin: 0;

            li {
                display: inline-block;
                margin: 0;
                padding: 0;
                margin-left: 1rem;

                &:first-child{
                    margin-left: 0;
                }
            }
        }
    }
}
</style>
